import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/drone/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/drone/src/node_modules/@babel/runtime/regenerator/index.js";
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function read(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += '; ' + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
  }
  function get(key) {
    if (typeof document === 'undefined' || arguments.length && !key) {
      return;
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {}
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set: set,
    get: get,
    remove: function remove(key, attributes) {
      set(key, '', assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function withConverter(converter) {
      return init(assign({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}
var api = init(defaultConverter, {
  path: '/'
});
var defaultOptions = {
  dhhTokenName: 'dhh_token',
  refreshTokenName: 'refresh_token',
  refreshTokenEndpoint: '/auth/refresh_token',
  oktaLoginEndpoint: '/auth/okta_token',
  skipAutoLoginInterceptor: false
};
var getDHIamTokens = function getDHIamTokens(dhhTokenName, refreshTokenName) {
  var cookiesImpl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : api;
  return {
    dhhTokenString: cookiesImpl.get(dhhTokenName),
    refreshTokenString: cookiesImpl.get(refreshTokenName)
  };
};
var clearCookies = function clearCookies() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var cookiesImpl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : api;
  cookiesImpl.remove(options.dhhTokenName);
  cookiesImpl.remove(options.refreshTokenName);
};
var exchangeCall = null;
var requestInterceptor = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config, exchangeOktaTokenImpl, options, notAuthorizedHandler, onLoginHandler) {
    var _getDHIamTokens, dhhTokenString, refreshTokenString, tokens;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getDHIamTokens = getDHIamTokens(options.dhhTokenName, options.refreshTokenName), dhhTokenString = _getDHIamTokens.dhhTokenString, refreshTokenString = _getDHIamTokens.refreshTokenString;
            if (!(dhhTokenString && refreshTokenString)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", config);
          case 3:
            _context.prev = 3;
            if (!exchangeCall) {
              exchangeCall = exchangeOktaTokenImpl();
            }
            _context.next = 7;
            return exchangeCall;
          case 7:
            tokens = _context.sent;
            if (exchangeCall) {
              if (onLoginHandler) {
                onLoginHandler(tokens);
              }
              exchangeCall = null;
            }
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            // Only report errors once, doesnt matter how many request were waiting
            exchangeCall = null;
            notAuthorizedHandler(undefined, "token exchanging failed: ".concat(_context.t0 instanceof Error ? _context.t0.message : _context.t0));
          case 15:
            return _context.abrupt("return", config);
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 11]]);
  }));
  return function requestInterceptor(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
var exchangeOktaToken = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(endpoint) {
    var noCookie,
      response,
      data,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            noCookie = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
            _context2.next = 3;
            return fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                no_cookie: noCookie
              }),
              credentials: 'same-origin'
            });
          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return response.json();
          case 6:
            data = _context2.sent;
            if (!(response.status >= 400 && response.status <= 500)) {
              _context2.next = 9;
              break;
            }
            throw Error(data.error);
          case 9:
            return _context2.abrupt("return", data);
          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function exchangeOktaToken(_x6) {
    return _ref2.apply(this, arguments);
  };
}();
var refreshAccessToken = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(refreshToken, refreshTokenEndpoint) {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetch(refreshTokenEndpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                refresh_token: refreshToken
              }),
              credentials: 'same-origin'
            });
          case 2:
            response = _context3.sent;
            _context3.next = 5;
            return response.json();
          case 5:
            data = _context3.sent;
            return _context3.abrupt("return", data);
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function refreshAccessToken(_x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();
function e(e) {
  this.message = e;
}
e.prototype = new Error(), e.prototype.name = "InvalidCharacterError";
var r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function (r) {
  var t = String(r).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) ? c += String.fromCharCode(255 & n >> (-2 * a & 6)) : 0) {
    o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
  }
  return c;
};
function t(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function (e) {
      return decodeURIComponent(r(e).replace(/(.)/g, function (e, r) {
        var t = r.charCodeAt(0).toString(16).toUpperCase();
        return t.length < 2 && (t = "0" + t), "%" + t;
      }));
    }(t);
  } catch (e) {
    return r(t);
  }
}
function n(e) {
  this.message = e;
}
function o(e, r) {
  if ("string" != typeof e) throw new n("Invalid token specified");
  var o = !0 === (r = r || {}).header ? 0 : 1;
  try {
    return JSON.parse(t(e.split(".")[o]));
  } catch (e) {
    throw new n("Invalid token specified: " + e.message);
  }
}
n.prototype = new Error(), n.prototype.name = "InvalidTokenError";
var DEFAULT_JWT_COOKIE_NAME = 'dhh_token';
var DEFAULT_REFRESH_TOKEN_COOKIE_NAME = 'refresh_token';
var DEFAULT_TOKEN_COOKIE_OPTIONS = {
  jwtCookieName: DEFAULT_JWT_COOKIE_NAME,
  refreshTokenCookieName: DEFAULT_REFRESH_TOKEN_COOKIE_NAME
};
var Token = /*#__PURE__*/function () {
  function Token(jwt, refreshToken) {
    _classCallCheck(this, Token);
    _defineProperty(this, "decoded", void 0);
    _defineProperty(this, "refreshToken", void 0);
    this.decoded = o(jwt);
    this.refreshToken = refreshToken;
  }
  _createClass(Token, [{
    key: "isExpired",
    value: function isExpired() {
      // new Date().getTime() returns a UNIX timestamp in ms
      // while the token payload has a UNIX timestamp in seconds
      return this.decoded.exp <= new Date().getTime() / 1000;
    }
  }], [{
    key: "fromCookies",
    value: function fromCookies() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TOKEN_COOKIE_OPTIONS;
      var cookiesImpl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : api;
      var _getDHIamTokens2 = getDHIamTokens(options.jwtCookieName, options.refreshTokenCookieName, cookiesImpl),
        dhhTokenString = _getDHIamTokens2.dhhTokenString,
        refreshTokenString = _getDHIamTokens2.refreshTokenString;
      Token.assertValidTokenProperties(dhhTokenString !== null && dhhTokenString !== void 0 ? dhhTokenString : null, refreshTokenString !== null && refreshTokenString !== void 0 ? refreshTokenString : null, options);
      return new Token(dhhTokenString, refreshTokenString);
    }
  }, {
    key: "assertValidTokenProperties",
    value: function assertValidTokenProperties(jwt, refreshToken) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_TOKEN_COOKIE_OPTIONS;
      if (jwt === null || refreshToken === null) {
        throw new Error("Missing cookie ".concat(options.jwtCookieName, " or ").concat(options.refreshTokenCookieName));
      }
    }
  }]);
  return Token;
}(); // Required for Axios manipulation?
var refreshCall = null;
var createTokenRefreshCall = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(currentRefreshToken, refreshTokenEndpoint) {
    var options,
      _yield$refreshAccessT,
      dhhToken,
      refreshToken,
      _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : defaultOptions;
            _context4.prev = 1;
            _context4.next = 4;
            return refreshAccessToken(currentRefreshToken, refreshTokenEndpoint);
          case 4:
            _yield$refreshAccessT = _context4.sent;
            dhhToken = _yield$refreshAccessT.dhhToken;
            refreshToken = _yield$refreshAccessT.refreshToken;
            api.set(options.dhhTokenName, dhhToken);
            api.set(options.refreshTokenName, refreshToken);
            return _context4.abrupt("return", true);
          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](1);
            // Log unexpected refresh error for debugging purposes
            // eslint-disable-next-line no-console
            console.error(_context4.t0);
            return _context4.abrupt("return", false);
          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 12]]);
  }));
  return function createTokenRefreshCall(_x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();
var unauthorizedHandler = function unauthorizedHandler(axiosInstance, notAuthorizedHandler, refreshEndpoint) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultOptions;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(error) {
      var _error$response, _error$response2;
      var clearRequest, _getDHIamTokens3, dhhTokenString, refreshTokenString, token, _refreshCall, success;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              clearRequest = function clearRequest() {
                clearCookies(options);
                notAuthorizedHandler(error);
              };
              if (!((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) !== 401 || !(error !== null && error !== void 0 && (_error$response2 = error.response) !== null && _error$response2 !== void 0 && _error$response2.config))) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return", Promise.reject(error));
            case 3:
              _getDHIamTokens3 = getDHIamTokens(options.dhhTokenName, options.refreshTokenName), dhhTokenString = _getDHIamTokens3.dhhTokenString, refreshTokenString = _getDHIamTokens3.refreshTokenString;
              if (!(!dhhTokenString || !refreshTokenString)) {
                _context5.next = 7;
                break;
              }
              clearRequest();
              return _context5.abrupt("return", Promise.reject(error));
            case 7:
              _context5.prev = 7;
              token = new Token(dhhTokenString, refreshTokenString);
              if (token.isExpired()) {
                _context5.next = 11;
                break;
              }
              throw error;
            case 11:
              if (!error.config.skipTokenRefresh) {
                refreshCall = (_refreshCall = refreshCall) !== null && _refreshCall !== void 0 ? _refreshCall : createTokenRefreshCall(token.refreshToken, refreshEndpoint, options);
              }
              _context5.next = 14;
              return refreshCall;
            case 14:
              success = _context5.sent;
              refreshCall = null;
              error.config.skipTokenRefresh = true;
              if (success) {
                _context5.next = 19;
                break;
              }
              throw error;
            case 19:
              _context5.next = 21;
              return axiosInstance(error.response.config);
            case 21:
              return _context5.abrupt("return", _context5.sent);
            case 24:
              _context5.prev = 24;
              _context5.t0 = _context5["catch"](7);
              clearRequest();
              throw _context5.t0;
            case 28:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[7, 24]]);
    }));
    return function (_x11) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var createDHHInterceptors = function createDHHInterceptors(axiosInstance, authBaseUrl, onUnauthorizedHandler, onLoginHandler) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var mergedOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
  var exchangeOktaTokenImpl = function exchangeOktaTokenImpl() {
    return exchangeOktaToken("".concat(authBaseUrl).concat(mergedOptions.oktaLoginEndpoint));
  };
  var clearTokensImpl = function clearTokensImpl() {
    return clearCookies(mergedOptions);
  };
  if (!mergedOptions.skipAutoLoginInterceptor) {
    axiosInstance.interceptors.request.use(function (config) {
      return requestInterceptor(config, exchangeOktaTokenImpl, mergedOptions, onUnauthorizedHandler, onLoginHandler);
    });
  }
  axiosInstance.interceptors.response.use(function (response) {
    return response;
  }, unauthorizedHandler(axiosInstance, onUnauthorizedHandler, "".concat(authBaseUrl).concat(mergedOptions.refreshTokenEndpoint), mergedOptions));
  return {
    exchangeOktaToken: exchangeOktaTokenImpl,
    clearTokens: clearTokensImpl
  };
};
var CLOUDFLARE_ACCESS_LOGOUT_PATH = '/cdn-cgi/access/logout';
export { CLOUDFLARE_ACCESS_LOGOUT_PATH, createDHHInterceptors };